import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import {
    ChronosLicense,
    EMPTY_LICENSE_CU_USAGE_DATA,
    LicenseCUUsageData,
} from "userful-chronos-app-common-js/dist/models/license/license";
import { requestActivateLicense, requestUpdateLicense, requestUploadLicense } from "./msgs/MsgSender";

const initialState: {
    initialLicense: ChronosLicense;
    license: ChronosLicense;
    licenseCUUsage: LicenseCUUsageData;
    ready: boolean;
    activatingLicense: boolean;
    activatingLicenseError: string;
} = {
    initialLicense: null,
    license: null,
    licenseCUUsage: EMPTY_LICENSE_CU_USAGE_DATA,
    ready: false,
    activatingLicense: false,
    activatingLicenseError: null,
};

export const licenseSlice = createSlice({
    name: "licenseSlice",
    initialState,
    reducers: {
        setLicense: (state, action: PayloadAction<ChronosLicense>) => {
            state.ready = true;
            if (action.payload && action.payload.issueDate > 0) {
                // aether create a "invalid license" if there is no license with issueDate = 0. UI want it as null in this case
                state.license = { ...action.payload };
                state.initialLicense = { ...action.payload };
                state.activatingLicenseError = null;
            } else if (state.activatingLicense) {
                state.activatingLicenseError = action.payload.failure;
            }
            state.activatingLicense = false;
        },
        clearLicense: (state) => {
            state.ready = true;
            state.license = null;
            state.activatingLicense = false;
        },

        refreshLicense: (state, action: PayloadAction<StringID>) => {
            state.activatingLicense = true;
            state.activatingLicenseError = null;
            requestUpdateLicense(action.payload);
        },
        setLicenseCUUsage: (state, action: PayloadAction<LicenseCUUsageData>) => {
            state.licenseCUUsage = action.payload;
        },
        activateLicense: (
            state,
            action: PayloadAction<{
                displays: number;
                activationCode: string;
                gpus: number;
                cpus: number;
                cu: number;
                engage: number;
                systemID: StringID;
            }>,
        ) => {
            state.activatingLicense = true;
            state.activatingLicenseError = null;
            requestActivateLicense(
                action.payload.systemID,
                action.payload.displays,
                action.payload.activationCode,
                action.payload.gpus,
                action.payload.cpus,
                action.payload.engage,
                action.payload.cu,
            );
        },
        uploadLicense: (
            state,
            action: PayloadAction<{
                veID: StringID;
                licenseString: string;
            }>,
        ) => {
            state.activatingLicense = true;
            state.activatingLicenseError = null;
            requestUploadLicense(action.payload.veID, action.payload.licenseString);
        },
        clearError: (state) => {
            state.activatingLicenseError = null;
        },
        reset: (state) => {
            state.ready = false;
        },
    },
});

export const licenseActions = licenseSlice.actions;

export default licenseSlice.reducer;
